import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHandleModuleNavigation } from '../../hooks';
import { useModulePage } from '../../hooks/queryParams/useModulePage';
import formValidationErrorIndication from '../../modules/campaigns/config/indications/validationIndication';
import { useMultiLayerDrawerEnabled } from '../../modules/multi-layer-drawer/hooks/useMultiLayerDrawerEnabled';
import { addIndication } from '../../modules/taboola-common-frontend-modules/Indications';

export const ModuleComponent = ({ routes, path, ...params }) => {
    const dispatch = useDispatch();
    const { modulePage: ModulePage, provider: Provider } = useModulePage(routes);

    const handleNavigation = useHandleModuleNavigation({ path });
    const onValidationError = useCallback(() => {
        dispatch(addIndication(formValidationErrorIndication));
    }, [dispatch]);

    const isRenderReportConstantlyEnabled = useMultiLayerDrawerEnabled();

    if (!ModulePage || !isRenderReportConstantlyEnabled) {
        return null;
    }

    if (Provider) {
        return (
            <Provider>
                <ModulePage {...params} onCancel={handleNavigation} onValidationError={onValidationError} />
            </Provider>
        );
    }

    return <ModulePage {...params} onCancel={handleNavigation} onValidationError={onValidationError} />;
};
